module.exports = __webpack_public_path__ + "static/media/more-feature.d20ee940.svg";